// Dodatek do ui/i18n.ts (patch-33): napisy, które trzeba ułożyć na nowo po zmianie EN/PL (a nie tylko przepisać),
// np. nagłówek z podkreślonym słowem, rząd przycisków, komunikat pod formularzem.
import type { TeacherLang } from '../types.ts';
import type { AppCtx } from './ctx.ts';
import { langOf, onLang } from './i18n.ts';

const gone = (el: Element): boolean => (el as { isConnected?: boolean }).isConnected === false;

/** Wywołuje `fn(lang)` po każdej zmianie języka, dopóki `anchor` jest na stronie (potem nasłuch odpina się sam). Bez `ctx.teacher` nic nie robi. */
export function liveLang(ctx: Pick<AppCtx, 'teacher'>, anchor: Element, fn: (lang: TeacherLang) => void): void {
  const off = onLang(ctx, (lang) => {
    if (gone(anchor)) off();
    else fn(lang);
  });
}

/**
 * Komunikat pod formularzem (błąd, „Zapisuję…”): zapamiętuje, CO pokazać (funkcja składająca napis), więc po zmianie języka
 * przepisuje się sam. `show(null)` czyści. Funkcja dostaje bieżący język — surowy tekst (np. z serwera) zwraca bez zmian.
 */
export function liveStatus(ctx: Pick<AppCtx, 'teacher'>, el: Element): { show(text: ((lang: TeacherLang) => string) | null): void } {
  let current: ((lang: TeacherLang) => string) | null = null;
  const paint = (): void => {
    el.textContent = current ? current(langOf(ctx)) : '';
  };
  liveLang(ctx, el, paint);
  return {
    show(text) {
      current = text;
      paint();
    },
  };
}
